import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AdminShell } from './admin-shell';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Admin root element is missing');

createRoot(root).render(
  <StrictMode>
    <AdminShell />
  </StrictMode>,
);
